import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Layout from './Layout/Layout';
import './HomePage.css';

import BannerImage from '../assets/banner.jpg';
import NorthAmericaImage from '../assets/northamerica.jpg';
import CentralAmericaImage from '../assets/centralamerica.jpg';
import EuropeImage from '../assets/europe.jpg';
import AsiaImage from '../assets/asia.jpg';
import OceaniaImage from '../assets/oceania.jpg';

// Array of continent objects for easy mapping
const continents = [
  { name: "North America", image: NorthAmericaImage, link: "/northamerica" },
  { name: "Central America", image: CentralAmericaImage, link: "/centralamerica" },
  { name: "Europe", image: EuropeImage, link: "/europe" },
  { name: "Asia", image: AsiaImage, link: "/asia" },
  { name: "Oceania", image: OceaniaImage, link: "/oceania" },
];

const HomePage = () => {
  return (
    <Layout>
      <Helmet>
        <title>The Half Time Travel Website - Family Travel Adventures & Itineraries</title>
        <meta
          name="description"
          content="Explore family travel adventures, itineraries, road trips, and off-the-beaten-path experiences across North America, Europe, Asia, and Oceania. Plan your next journey with The Half Time Travel Website."
        />
        <meta property="og:title" content="The Half Time Travel Website - Family Travel Adventures" />
        <meta
          property="og:description"
          content="Discover unique family travel experiences and itineraries across continents. Plan your next adventure with The Half Time Travel Website."
        />
        <meta property="og:image" content={BannerImage} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TravelBlog",
            "name": "The Half Time Travel Website",
            "description": "Family travel adventures and detailed itineraries across continents",
            "url": "https://www.thehalftimewhistle.com",
            "image": BannerImage,
            "author": {
              "@type": "Person",
              "name": "Shantanu, Kapila, Shaurya, and Nitara"
            }
          })}
        </script>
      </Helmet>

      <div className="home-page">
        <header className="header">
          <div className="banner">
            <img
              src={BannerImage}
              alt="The Half Time Travel Website Banner"
              className="banner-image"
              loading="lazy"
            />
            <h1 className="banner-text">Welcome to The Half Time Travel Website</h1>
          </div>
        </header>

        <main className="main-content">
          <section className="common-block">
            <h2>Our Family Travel Philosophy</h2>
            <p>
              We love to travel as a family—exploring new destinations, experiencing diverse cultures, and embracing the life of true wanderers. When we plan a trip, the process of creating the itinerary is often a daunting task. We prefer to explore like locals—renting cars, staying in Airbnbs, and stepping off the beaten path.
            </p>
            <p>
              For a long time, I've wanted to create a log of all our travel experiences in one place—a space that not only serves as our family travelogue, allowing us to relive our cherished memories, but also as a resource for others. We hope that people will read about our adventures and, perhaps, feel inspired to visit some of the places we've been.
            </p>
            <h3>Why "Half Time Whistle"?</h3>
            <p>
              In any game, a whistle signals a break—a time to refuel, rejuvenate, and rethink. Our Half Time Whistle website is inspired by this concept, encouraging you to take a pause from your busy life to wander, explore, and rediscover the world.
            </p>
            <p>
              Half Time Whistle is not just a travel website; it's a piece of our heart and soul. It's a collection of our memories, woven together with passion and love. We hope you enjoy this space as much as we enjoy creating and nurturing it.
            </p>
            <p className="signature">Shantanu, Kapila, Shaurya, and Nitara</p>
          </section>

          <section className="content-blocks">
            {continents.map(continent => (
              <Link
                key={continent.name}
                to={continent.link}
                className="block"
              >
                <article className="block-content">
                  <img
                    src={continent.image}
                    alt={`${continent.name} Travel Destinations`}
                    loading="lazy"
                  />
                  <h2>{continent.name}</h2>
                </article>
              </Link>
            ))}
          </section>
        </main>
      </div>
    </Layout>
  );
};

export default HomePage;
